import { useState } from 'react';
import { toast } from 'react-toastify';
import { SOLICITUD_ALTERNATIVAS_API } from '../../../shared/services/solicitudAlternativas';
import ActionButton from '../ActionButton';
import { ModalSection, ModalPanel } from '../layout/ModalSection';
import EnviarRespuestaAviso from '../layout/EnviarRespuestaAviso';
import PresupuestoOrigenFields from '../PresupuestoOrigenFields';
import { normalizePiezas } from '../../utils';

const SinAlternativaModal = ({ currentItem, onClose, onSolicitudUpdated }) => {
    const [motivo, setMotivo] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const piezas = normalizePiezas(currentItem);

    const handleSubmit = async () => {
        const trimmed = motivo.trim();
        if (!trimmed) {
            toast.error('Debes indicar el motivo.');
            return;
        }

        setSubmitting(true);
        try {
            const res = await SOLICITUD_ALTERNATIVAS_API.sinAlternativa({
                solicitud_id: currentItem.id,
                motivo: trimmed,
            });
            if (res?.success) {
                toast.success('Respuesta enviada correctamente.');
                onSolicitudUpdated?.(res.data);
                onClose();
            } else {
                toast.error(
                    res?.message || 'No se ha podido enviar la respuesta.',
                );
            }
        } catch (e) {
            toast.error(
                e?.response?.data?.message ||
                    e?.message ||
                    'Error al enviar la respuesta.',
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <ModalSection title="Presupuesto origen">
                <ModalPanel className="card p-3 p-md-4 mb-4">
                    <div className="row g-3">
                        <PresupuestoOrigenFields
                            layout="sinAlternativa"
                            origen={currentItem?.origen}
                            piezas={piezas}
                            fechaLabel="Fecha presupuesto"
                            clienteDisplay="stack"
                        />
                    </div>
                </ModalPanel>
            </ModalSection>

            <ModalSection title="Motivo">
                <textarea
                    className="form-control mb-4"
                    rows={4}
                    placeholder="Indica el motivo por el que no hay alternativa disponible..."
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                />
            </ModalSection>

            <EnviarRespuestaAviso />

            <div className="d-flex justify-content-end">
                <ActionButton
                    disabled={submitting || !motivo.trim()}
                    loading={submitting}
                    label="Enviar respuesta"
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};

export default SinAlternativaModal;
